import { createFileRoute } from "@tanstack/react-router";
import { HomePage, homeLoader, homeHeadEn } from "@/pages/HomePage";

export const Route = createFileRoute("/en/")({
  loader: homeLoader,
  head: homeHeadEn,
  component: HomePage,
});
